import { Space, Typography } from 'antd'
import { useFormik } from 'formik'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import CustomLabel from 'general/components/CustomLabel'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import { useRef } from 'react'
import * as Yup from 'yup'

export default function ModalChangeHSMPasscode({
  open,
  onOpenChange,
  onApply,
}) {
  const modalRef = useRef(null)

  const validationSchema = Yup.object({
    currentPasscode: Yup.string().required('Vui lòng nhập mật khẩu hiện tại'),
    newPasscode: Yup.string()
      .required('Vui lòng nhập mật khẩu mới')
      .test(
        'different-from-current',
        'Mật khẩu mới phải khác mật khẩu hiện tại',
        function (value) {
          return !value || value !== this.parent.currentPasscode
        },
      ),
    confirmNewPasscode: Yup.string()
      .required('Vui lòng nhập lại mật khẩu mới')
      .oneOf([Yup.ref('newPasscode')], 'Mật khẩu nhập lại không khớp'),
  })

  const formik = useFormik({
    initialValues: {
      currentPasscode: '',
      newPasscode: '',
      confirmNewPasscode: '',
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      const { currentPasscode, newPasscode } = values
      const result = await onApply({ currentPasscode, newPasscode })
      if (result !== false) {
        resetForm()
      }
    },
  })

  const fields = [
    {
      name: 'currentPasscode',
      label: 'Mật khẩu hiện tại',
      placeholder: 'Nhập mật khẩu hiện tại',
      autoComplete: 'current-password',
    },
    {
      name: 'newPasscode',
      label: 'Mật khẩu mới',
      placeholder: 'Nhập mật khẩu mới',
      autoComplete: 'new-password',
    },
    {
      name: 'confirmNewPasscode',
      label: 'Nhập lại mật khẩu mới',
      placeholder: 'Nhập lại mật khẩu mới',
      autoComplete: 'new-password',
    },
  ]

  return (
    <DraggableModal
      ref={modalRef}
      title="Đổi mật khẩu HSM"
      isOpen={open}
      onOpenChange={(state) => {
        onOpenChange(state)
        formik.resetForm()
      }}
      handleApplyChanges={formik.submitForm}
      applyText="Đổi mật khẩu"
      hasCancelButton
      isLoading={formik.isSubmitting}
      styles={{ body: { paddingTop: 0 } }}
      width={500}
    >
      <Space direction="vertical" size="middle" className="w-100">
        {fields.map(({ name, label, placeholder, autoComplete }) => (
          <div className="w-100" key={name}>
            <CustomLabel
              htmlFor={name}
              isRequired
              text={label}
              fontWeight={500}
              width="100%"
            />
            <CustomAntInput
              borderRadius="sm"
              type="password"
              width="100%"
              inputProps={{
                autoComplete,
                name,
                placeholder,
                visibilityToggle: true,
                status: formik.errors[name] && formik.touched[name] && 'error',
                ...formik.getFieldProps(name),
              }}
            />
            {formik.touched[name] && formik.errors[name] ? (
              <Typography.Text type="danger">
                {formik.errors[name]}
              </Typography.Text>
            ) : null}
          </div>
        ))}
      </Space>
    </DraggableModal>
  )
}
